import React from "react";
import { useFela } from "react-fela";
import useTranslation from "next-translate/useTranslation";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";

export const Error: React.FC = props => {
  const { t } = useTranslation("repair-file-service");
  const { css } = useFela();
  const { colors } = useTheme();

  return (
    <div
      className={css({
        flex: 1,
        display: "flex",
        flexDirection: "column",
      })}
    >
      <Heading as="h4" customStyle={{ fontSize: 20, color: colors.RED }}>
        {t("error.title")}
      </Heading>

      <p
        className={css({
          marginTop: 10,
          fontSize: 16,
          fontWeight: 500,
          lineHeight: 1.7,
          color: colors.MAASTRICHT_BLUE,
        })}
      >
        {t("error.description")}
      </p>

      {props.children}
    </div>
  );
};
